import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import {ExamTypeService} from '../../../core/services/exam-type/document-type/exam-type.service'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {MatIcon} from '@angular/material/icon';
import {ResponseRequestModel} from '../../../core/models/response.model';
import {
  MessageTypeCreateComponent
} from '../../../features/message-type/document-type-create/message-type-create.component';
import {MessageTypeEditComponent} from '../../../features/message-type/document-type-edit/message-type-edit.component';
import {MessageTypeService} from '../../../core/services/message-type/document-type/message-type.service';

@Component({
  selector: 'message-type',
  imports: [
    MatCard,
    MatProgressBar,
    TableListComponent,
    MatPaginatorModule,
    MatIcon,
    MessageTypeCreateComponent,
  ],
  templateUrl: './message-type.component.html',
  styleUrl: './message-type.component.scss',
  providers: [MessageTypeService, AuthService],
  standalone: true,
})
export class MessageTypeComponent implements OnInit {
  constructor(
    private examTypeService: MessageTypeService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'nome',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'tipos-de-uso'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    const items = Array.isArray(response?.data)
      ? response.data
      : (Array.isArray(response?.items) ? response.items : (response?.data?.items ?? []))
    for (let item of items) {
      list.push(item)
    }
    this.itemsList = list
    this.numberRows = response?.totalItens ?? response?.paging?.total ?? response?.pagination?.total ?? this.itemsList.length
  }

  getListItems() {
    this.loading = true
    this.examTypeService
      .listMessageType()
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: any) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.examTypeService
      .searchPagedDocumentType(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: any) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(MessageTypeEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    this.examTypeService.deleteMessageType(item.id).subscribe({
      next: (response: ResponseRequestModel)=>{
        this.uploadList()
      }, error: (error) =>{
        console.log(error)
      }
    })
  }

}
